import ClickableBackground from "./ClickableBackground"
export default ClickableBackground
